module.exports = __webpack_public_path__ + "img/logo.a5555403.svg";